import config from "config/config.js";
import getFreshToken from "utils/xsrfToken.js";

const changePassword = newPassword => {
  const xsrfToken = getFreshToken();

  const endpoint = `${config.baseUrl}/api/changePassword`;
  return fetch(endpoint)
    .then(response => {
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      console.log(response);
      const result = {
        status: "ok",
        success: true,
        accessToken: response.accessToken,
        xsrfToken: response.xsrfToken
      };
      return result;
    });
};
export default changePassword;



// WEBPACK FOOTER //
// ./src/utils/changePassword.js